export const Moon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-container">
    <path
      d="M20.0701 12.0003C19.3895 13.1769 19 14.543 19 16C19 20.3949 22.5439 23.9621 26.9299 23.9997C25.5467 26.3911 22.9613 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12C20.0234 12 20.0467 12.0001 20.0701 12.0003Z"
      fill="#242424"
    />
  </svg>
);
